/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Attribute } from './attribute';
import { BusinessObjectDefinitionChangeEvent } from './businessObjectDefinitionChangeEvent';
import { DescriptiveBusinessObjectFormat } from './descriptiveBusinessObjectFormat';
import { SampleDataFile } from './sampleDataFile';


export interface BusinessObjectDefinition { 
    /**
     * The internal identifier that uniquely references a Business Object Definition
     */
    id?: number;
    /**
     * The name of a valid Namespace known by the system
     */
    namespace: string;
    /**
     * The name for this Business Object Definition
     */
    businessObjectDefinitionName: string;
    /**
     * The name of a valid Data Provider known by the system
     */
    dataProviderName?: string;
    /**
     * An optional Department code
     */
    departmentCode?: string;
    /**
     * An optional description
     */
    description?: string;
    /**
     * An optional short-description. This is actually the 'description' field truncated to a configurable number of characters                
     */
    shortDescription?: string;
    /**
     * An optional business friendly name
     */
    displayName?: string;
    /**
     * Custom user-defined metadata associated with this Business Object Definition. \"name\" is the attribute name (i.e. the key) and                   \"value\" is the attribute value                
     */
    attributes?: Array<Attribute>;
    descriptiveBusinessObjectFormat?: DescriptiveBusinessObjectFormat;
    /**
     * An optional list of sample data files associated with the Business Object Definition
     */
    sampleDataFiles?: Array<SampleDataFile>;
    /**
     * The User ID of the user who created this business object definition
     */
    createdByUserId?: string;
    /**
     * The User ID of the user who last updated this business object definition
     */
    lastUpdatedByUserId?: string;
    /**
     * The timestamp when this business object definition was last updated on
     */
    lastUpdatedOn?: Date;
    /**
     * A list of business object definition change events
     */
    businessObjectDefinitionChangeEvents?: Array<BusinessObjectDefinitionChangeEvent>;
}
